import { all, put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import api from "~/services/api";
import { Creators as AccountActions, Types as AccountTypes } from "~/store/modules/accounts";
import { getError } from  "~/helper";

export function* createOrUpdate({ data, actForm }) {
  try {
    let editing = !!((data && data.id));
    let method = editing ? api.put : api.post;
    let path = editing ? 'update' : 'create';

    yield call(method, `accounts/${path}`, data);
    yield put(AccountActions.listAccountsRequest(0));

    showSuccess(editing);
    actForm.closeModal();
  } catch (error) {
    showError(error);
  } finally {
    if (actForm) {
      actForm.setSubmitting(false);
    }
  }
}

export function showSuccess(editing) {
    toast.success(`Conta ${editing ? "atualizada" : "criada"} com sucesso`);
}

export function showError(error) {
    const msg =  getError(error);
    toast.error(msg);
}

export function* listAccounts({page = 0, term}) {
    try {
      if (page === 0) {
        yield put(AccountActions.resetStateAccount());
      }
      const response = yield call(api.get, "accounts/list", { params: {page, term} });
      yield put(AccountActions.listAccountsFinish(response.data));
    } catch (error) {
      showError(error);
    }
}

export function* cnpjSearch({cnpj}) {
  try {
    const response = yield call(api.get, "accounts/external", { params: {cnpj} });
    yield put(AccountActions.searchAccountCnpjSuccess(response.data));
  } catch (error) {
    yield put(AccountActions.searchAccountCnpjFailed());
    showError(error);
  }
}

export default all([
    takeLatest(AccountTypes.CREATE_OR_UPDATE_ACCOUNT, createOrUpdate),
    takeLatest(AccountTypes.LIST_ACCOUNTS_REQUEST, listAccounts),
    takeLatest(AccountTypes.SEARCH_ACCOUNT_CNPJ_REQUEST, cnpjSearch),
])
